import Storage from "../storage";

export function updateGloop(data, sendToServer = true, log = {}) {
	let state = Storage.getState();
	Storage.dispatch({
		type : 'EDIT GLOOP',
		id : state.activeGloop,
		data : data,
		sendToServer: sendToServer,
		log : log
	});
}

export function Share(to = '') {
	if(!window.userLevels['1563130796'] || !window.userLevels['1563130796'].Active){
		window.userData.registration_coupon -= 1;
	}
	let state = Storage.getState();
	Storage.dispatch({
		type : 'SHARE',
		id : state.activeGloop,
		to : to
	});
}